<div class="host-system-notification-dynamic">
  <div class="n-container">
    <div class="n-top">
      <div class="n-icon">
        <i nz-icon nzType="info-circle" nzTheme="outline" class="info-icon"></i>
      </div>
      <div class="n-title">
        {{ notification?.title }}
      </div>
    </div>
    <div class="n-body">
      <div class="n-content" [innerHTML]="notification?.content">
      </div>
      <div class="n-footer" *ngIf="notification?.has_button">
        <button nz-button nzType="primary" (click)="onClickBtn()">{{ notification?.button_title }}</button>
      </div>
    </div>
  </div>
</div>
